import { get } from 'lodash-es'
import FORM_CONSTANTS from '@/js/components/Forms/ComplaintForm/_store-module/constants.js'
import ComplaintFormImageDataMixin from '@/js/components/Forms/ComplaintForm/_mixins/complaint-form-image-data-mixin.js'

export default {
  mixins: [ComplaintFormImageDataMixin],
  methods: {
    getModelTypeItems({ isBuyEngineForm = false }) {
      const items = [
        {
          text: FORM_CONSTANTS.COMPLAINT_FORM_IMPULSE_PRODUCT_DATA_CONSTANTS.MODEL_TYPE
            .MODEL_TYPE_IMPULSE_EVO,
          value:
            FORM_CONSTANTS.COMPLAINT_FORM_IMPULSE_PRODUCT_DATA_CONSTANTS.MODEL_TYPE
              .MODEL_TYPE_IMPULSE_EVO,
          image: get(this.imageData, 'u151'),
        },
        {
          text: FORM_CONSTANTS.COMPLAINT_FORM_IMPULSE_PRODUCT_DATA_CONSTANTS.MODEL_TYPE
            .MODEL_TYPE_IMPULSE_2_0,
          value:
            FORM_CONSTANTS.COMPLAINT_FORM_IMPULSE_PRODUCT_DATA_CONSTANTS.MODEL_TYPE
              .MODEL_TYPE_IMPULSE_2_0,
          image: get(this.imageData, 'u145'),
        },
        {
          text: FORM_CONSTANTS.COMPLAINT_FORM_IMPULSE_PRODUCT_DATA_CONSTANTS.MODEL_TYPE
            .MODEL_TYPE_IMPULSE,
          value:
            FORM_CONSTANTS.COMPLAINT_FORM_IMPULSE_PRODUCT_DATA_CONSTANTS.MODEL_TYPE
              .MODEL_TYPE_IMPULSE,
          image: get(this.imageData, 'u147'),
        },
      ]

      if (!isBuyEngineForm) {
        items.push({
          text: FORM_CONSTANTS.COMPLAINT_FORM_IMPULSE_PRODUCT_DATA_CONSTANTS.MODEL_TYPE
            .MODEL_TYPE_CONTINENTAL,
          value:
            FORM_CONSTANTS.COMPLAINT_FORM_IMPULSE_PRODUCT_DATA_CONSTANTS.MODEL_TYPE
              .MODEL_TYPE_CONTINENTAL,
          image: get(this.imageData, 'u152'),
        })
      }

      return items
    },
    getModelTypeInfo(modelType) {
      switch (modelType) {
        case FORM_CONSTANTS.COMPLAINT_FORM_IMPULSE_PRODUCT_DATA_CONSTANTS.MODEL_TYPE
          .MODEL_TYPE_IMPULSE: {
          return {
            message: this.$t('complaintForm.ticket.engine.engine_series_no_find1'),
            image: get(this.imageData, 'u9', {}),
          }
        }
        case FORM_CONSTANTS.COMPLAINT_FORM_IMPULSE_PRODUCT_DATA_CONSTANTS.MODEL_TYPE
          .MODEL_TYPE_IMPULSE_2_0: {
          return {
            message: this.$t('complaintForm.ticket.engine.engine_series_no_find2'),
            image: get(this.imageData, 'u38', {}),
          }
        }
        case FORM_CONSTANTS.COMPLAINT_FORM_IMPULSE_PRODUCT_DATA_CONSTANTS.MODEL_TYPE
          .MODEL_TYPE_IMPULSE_EVO: {
          return {
            message: this.$t('complaintForm.ticket.engine.engine_series_nr_find_vo'),
            image: get(this.imageData, 'u71', {}),
          }
        }

        default: {
          return {}
        }
      }
    },
    getBikeTypeSelectItems() {
      return Object.keys(FORM_CONSTANTS.CONTINENTAL_BIKE_TYPES).map(key => ({
        value: key,
        text: FORM_CONSTANTS.CONTINENTAL_BIKE_TYPES[key],
      }))
    },
    getOrderTypeSelectItems({ modelType, isPickupCountry, buyBlock = false }) {
      const allModels = []

      if (!buyBlock) {
        allModels.push({
          text: this.$t('complaintForm.ticket.order_types.without_legacy_device_pick-up'),
          value: FORM_CONSTANTS.ORDER_TYPES.WITHOUT_LEGACY_DEVICE_PICK_UP,
        })
      }

      let models = allModels

      if (
        modelType ===
        FORM_CONSTANTS.COMPLAINT_FORM_IMPULSE_PRODUCT_DATA_CONSTANTS.MODEL_TYPE
          .MODEL_TYPE_CONTINENTAL
      ) {
        models = []
        if (!buyBlock) {
          models.push({
            text: this.$t(
              'complaintForm.ticket.order_types.continental_without_legacy_device_pick-up',
            ),
            value: FORM_CONSTANTS.ORDER_TYPES.WITHOUT_LEGACY_DEVICE_PICK_UP,
          })
        }

        models.push({
          text: this.$t('complaintForm.ticket.order_types.continental_with_legacy_device_pick-up'),
          value: FORM_CONSTANTS.ORDER_TYPES.WITH_LEGACY_DEVICE_PICK_UP,
        })
      } else if (
        isPickupCountry &&
        modelType !==
          FORM_CONSTANTS.COMPLAINT_FORM_IMPULSE_PRODUCT_DATA_CONSTANTS.MODEL_TYPE.MODEL_TYPE_IMPULSE
      ) {
        models = [
          ...allModels,
          {
            text: this.$t('complaintForm.ticket.order_types.with_legacy_device_pick-up'),
            value: FORM_CONSTANTS.ORDER_TYPES.WITH_LEGACY_DEVICE_PICK_UP,
          },
        ]
      }

      return models
    },
    getMotorTypeSelectItems(addAll = false) {
      const result = [
        {
          text: this.$t('complaintForm.ticket.engine.pedal_break'),
          value: FORM_CONSTANTS.ENGINE_TYPES.BACKPEDAL,
        },
        {
          text: this.$t('complaintForm.ticket.engine.freewheel'),
          value: FORM_CONSTANTS.ENGINE_TYPES.FREEWHEEL,
        },
      ]
      return addAll
        ? [
            ...result,
            {
              text: `${this.$t('complaintForm.ticket.engine.pedal_break')}/${this.$t(
                'complaintForm.ticket.engine.freewheel',
              )}`,
              value: 'all',
            },
          ]
        : [...result]
    },
    getCalculationWishSelectItems({
      isBuyEngineForm,
      orderType,
      isPickupCountry,
      isContinental = false,
      buyBlock = false,
    }) {
      if (isBuyEngineForm && buyBlock) {
        return []
      }
      if (isBuyEngineForm) {
        return this.getCalculationWishSelectItemsBuy(orderType, isContinental)
      }
      return this.getCalculationWishSelectItemsComplaint({
        orderType,
        isPickupCountry,
        isContinental,
        buyBlock,
      })
    },

    getCalculationWishSelectItemsComplaint({
      orderType,
      isPickupCountry = true,
      isContinental = false,
      buyBlock = false,
    }) {
      switch (orderType) {
        case FORM_CONSTANTS.ORDER_TYPES.WITH_LEGACY_DEVICE_PICK_UP: {
          const items = [
            {
              text: this.$t('complaintForm.ticket.engine.calculation_request.1'),
              value: FORM_CONSTANTS.CALCULATION_DESIRE_TYPES.CALCULATION_DESIRE_GUARANTEE,
            },
          ]
          if (!buyBlock && !isContinental) {
            items.push(
              // {
              //   text: this.$t('complaintForm.ticket.engine.calculation_request.1-1'),
              //   value:
              //     FORM_CONSTANTS.CALCULATION_DESIRE_TYPES
              //       .CALCULATION_DESIRE_POOL_ENGINE_IN_WARRANTY_PERIOD,
              // },
              {
                text: this.$t('complaintForm.ticket.engine.calculation_request.2'),
                value: FORM_CONSTANTS.CALCULATION_DESIRE_TYPES.CALCULATION_DESIRE_FEE_BASED,
              },
              // {
              //   text: this.$t('complaintForm.ticket.engine.calculation_request.5-3'),
              //   value:
              //     FORM_CONSTANTS.CALCULATION_DESIRE_TYPES
              //       .CALCULATION_DESIRE_NEW_ENGINE_WITH_LEGACY_DEVICE_PICK_UP,
              // },
              // {
              //   text: this.$t('complaintForm.ticket.engine.calculation_request.5'),
              //   value:
              //     FORM_CONSTANTS.CALCULATION_DESIRE_TYPES
              //       .CALCULATION_DESIRE_POOL_ENGINE_WITH_LEGACY_DEVICE_PICK_UP,
              // },
              // {
              //   text: this.$t('complaintForm.ticket.engine.calculation_request.1-3'),
              //   value:
              //     FORM_CONSTANTS.CALCULATION_DESIRE_TYPES
              //       .CALCULATION_DESIRE_NEW_ENGINE_IN_WARRANTY_PERIOD,
              // },
            )
          }
          return items
        }
        case FORM_CONSTANTS.ORDER_TYPES.WITHOUT_LEGACY_DEVICE_PICK_UP: {
          const result = []

          if (!buyBlock) {
            result.push({
              text: isContinental
                ? this.$t('complaintForm.ticket.engine.calculation_request.4-continental')
                : this.$t('complaintForm.ticket.engine.calculation_request.4'),
              value: FORM_CONSTANTS.CALCULATION_DESIRE_TYPES.CALCULATION_DESIRE_NEW_ENGINE,
            })
          }

          // if (!isContinental) {
          //   result.push({
          //     text: this.$t('complaintForm.ticket.engine.calculation_request.4-1'),
          //     value:
          //       FORM_CONSTANTS.CALCULATION_DESIRE_TYPES
          //         .CALCULATION_DESIRE_POOL_ENGINE_WITHOUT_LEGACY_DEVICE_PICK_UP,
          //   })
          // }

          if (!isPickupCountry) {
            result.push({
              text: this.$t('complaintForm.ticket.engine.calculation_request.4-4'),
              value:
                FORM_CONSTANTS.CALCULATION_DESIRE_TYPES
                  .CALCULATION_DESIRE_WARRANTY_WITHOUT_DEVICE_PICKUP_FOR_NO_PICK_UP_COUNTRIES,
            })
          }

          return result
        }
        default: {
          return []
        }
      }
    },
    getCalculationWishSelectItemsBuy(orderType, isContinental = false) {
      switch (orderType) {
        case FORM_CONSTANTS.ORDER_TYPES.WITH_LEGACY_DEVICE_PICK_UP: {
          return [
            {
              text: this.$t('complaintForm.ticket.engine.calculation_request.5-3'),
              value:
                FORM_CONSTANTS.CALCULATION_DESIRE_TYPES
                  .CALCULATION_DESIRE_NEW_ENGINE_WITH_LEGACY_DEVICE_PICK_UP,
            },
            // {
            //   text: this.$t('complaintForm.ticket.engine.calculation_request.5'),
            //   value:
            //     FORM_CONSTANTS.CALCULATION_DESIRE_TYPES
            //       .CALCULATION_DESIRE_POOL_ENGINE_WITH_LEGACY_DEVICE_PICK_UP,
            // },
          ]
        }
        case FORM_CONSTANTS.ORDER_TYPES.WITHOUT_LEGACY_DEVICE_PICK_UP: {
          const items = [
            {
              text: this.$t('complaintForm.ticket.engine.calculation_request.4'),
              value: FORM_CONSTANTS.CALCULATION_DESIRE_TYPES.CALCULATION_DESIRE_NEW_ENGINE,
            },
          ]

          // if (!isContinental) {
          //   items.push({
          //     text: this.$t('complaintForm.ticket.engine.calculation_request.4-1'),
          //     value:
          //       FORM_CONSTANTS.CALCULATION_DESIRE_TYPES
          //         .CALCULATION_DESIRE_POOL_ENGINE_WITHOUT_LEGACY_DEVICE_PICK_UP,
          //   })
          // }
          return items
        }
        default: {
          return []
        }
      }
    },
    getRepaiProcessType(calculationDesire) {
      return get(FORM_CONSTANTS.CALCULATION_DESIRE_TO_REPAIR_PROCESS_TYPE, calculationDesire)
    },
  },
}
